interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

export function CloseButton({ onClick, ariaLabel = "Close" }: CloseButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2D55FB] focus-visible:ring-offset-2 transition-colors"
    >
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <rect
          width="35"
          height="35"
          rx="17.5"
          fill="#e0e0e0"
        />
        <path
          d="M22.5 12.5L12.5 22.5"
          stroke="black"
          strokeWidth="0.717394"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 12.5L22.5 22.5"
          stroke="black"
          strokeWidth="0.717394"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
